import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Collapse,
  useMediaQuery,
  ListItemIcon,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PublicIcon from "@mui/icons-material/Public";
import StorageIcon from "@mui/icons-material/Storage";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import CodeIcon from "@mui/icons-material/Code";
import HomeIcon from "@mui/icons-material/Home";
import Logo from "/Images/Layer 4.svg";
import Logo2 from "/Images/Tennet (Putih) 1.svg"; // Import logo
import { useNavigate, useLocation } from "react-router-dom";
import { Popover, OverlayTrigger } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import CustodyIcon from "/Images/iconproducts1.svg";
import XcrowIcon from "/Images/iconproducts2.svg";
import OTCIcon from "/Images/iconproducts3.svg";

import SolutionIcon1 from "/Images/iconsolution1.svg";
import SolutionIcon2 from "/Images/iconsolution2.svg";

import CompanyIcon1 from "/Images/iconcompany1.svg";
import CompanyIcon2 from "/Images/iconcompany2.svg";

import DeveloperIcon1 from "/Images/icondeveloper1.svg";
import zIndex from "@mui/material/styles/zIndex";
import CloseIcon from "@mui/icons-material/Close"; // Import Close Icon

const popoverStyle = {
  borderRadius: "10px",
  maxWidth: "418.52px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
  padding: "0px",
  fontFamily: "Poppins, sans-serif",
  color: "#333",
  zIndex: 9999,
};

const styles = {
  dropdownContainer: {
    backgroundColor: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
    color: "#FFFFFF",
    padding: "10px 20px",
    borderRadius: "0 0 10px 10px",
    zIndex: 9999,
  },
  listItem: {
    color: "#FFFFFF",
    fontSize: "1rem",
    fontWeight: 600,
    padding: "10px 0",
  },
  listIcon: {
    color: "#FFFFFF",
  },
};

// const styles = {
//   drawerContainer: {
//     height: "100%", // Ensure gradient covers the full height
//     background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)", // Full height linear gradient
//     color: "#FFFFFF", // White text color
//     display: "flex",
//     flexDirection: "column",
//     padding: "0 16px",
//   },
//   logoContainer: {
//     display: "flex",
//     justifyContent: "center",
//     padding: "20px 0",
//   },
//   listItem: {
//     fontSize: "1rem",
//     fontWeight: 600, // Semi-bold
//     color: "#FFFFFF",
//   },
//   listIcon: {
//     color: "#FFFFFF", // White icon color
//   },
//   divider: {
//     backgroundColor: "#F4E37B", // Divider color
//     margin: "15px 0",
//   },
// };

// Styled Dropdown Menu
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      fontSize: "0.875rem",
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const Header = ({ heroRef, businessRef, forWhomRef }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [anchorElProducts, setAnchorElProducts] = useState(null);
  const [anchorElSolutions, setAnchorElSolutions] = useState(null);
  const [anchorElCompany, setAnchorElCompany] = useState(null);
  const [anchorElDevelopers, setAnchorElDevelopers] = useState(null);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [openProducts, setOpenProducts] = useState(false);
  const [openSolutions, setOpenSolutions] = useState(false);
  const [openCompany, setOpenCompany] = useState(false);
  const [openDevelopers, setOpenDevelopers] = useState(false);
  const [isProductsVisible, setProductsVisible] = useState(false);
  const [isSolutionsVisible, setSolutionsVisible] = useState(false);
  const [isCompanyVisible, setCompanyVisible] = useState(false);
  const [isDevelopersVisible, setDevelopersVisible] = useState(false);
  const popoverRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [openSections, setOpenSections] = useState({
    developers: false,
    chains: false,
    solutions: false,
    company: false,
    resources: false,
  });
  const toggleSection = (section) => {
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleToggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const closeAllPopovers = () => {
    setProductsVisible(false);
    setSolutionsVisible(false);
    setCompanyVisible(false);
    setDevelopersVisible(false);
  };

  const handlePopoverOpen = () => {
    setPopoverVisible(true);
  };

  const handlePopoverClose = () => {
    setPopoverVisible(false);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width: 991px)"); // Mobile media query
  const dropdownRef = useRef(null);

  const handleScrollToSection = (section) => {
    if (location.pathname !== "/usecase") {
      navigate("/usecase", { state: { section } });
    } else {
      const ref = section === "business" ? businessRef : forWhomRef;
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleBookMeeting = () => {
    navigate("/bookmeeting");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNavigateWithScroll = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const handleNavigateWithoutScroll = (path) => {
  //   navigate(path);
  //   setIsMobileOpen(false);
  //   window.scrollTo(0, 0); // Pindah tanpa smooth scroll
  // };

  const handleScrollToHome = () => {
    if (location.pathname !== "/home") {
      navigate("/home");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 300);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsMobileOpen(false); // Close the drawer after navigation
    setPopoverVisible(false); // Menutup popover setelah navigasi
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const handleClickOutside = (event) => {
  //   if (popoverRef.current && !popoverRef.current.contains(event.target)) {
  //     setPopoverVisible(false); // Menutup popover
  //   }
  // };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  // useEffect(() => {
  //   // Menambahkan event listener saat popover ditampilkan
  //   if (isPopoverVisible) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isPopoverVisible]);

  const productsPopover = (
    <Popover
      id="products-popover"
      ref={popoverRef}
      style={popoverStyle}
      onMouseEnter={() => setProductsVisible(true)}
      onMouseLeave={closeAllPopovers}
    >
      <Popover.Body>
        <div
          onClick={() => handleNavigateWithScroll("/custody")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#E0DCD9")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
            width: "100%", // Menutupi seluruh lebar popover
          }}
        >
          <img
            src={CustodyIcon}
            alt="Custody"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              Custody
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Hot, warm, and cold custody platform
            </p>
          </div>
        </div>

        <div
          onClick={() => handleNavigateWithScroll("/xcrow")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#E0DCD9")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "none",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
            width: "100%", // Menutupi seluruh lebar popover
          }}
        >
          <img
            src={XcrowIcon}
            alt="Xcrow"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              Xcrow
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Crypto escrow service platform
            </p>
          </div>
        </div>

        <div
          onClick={() => handleNavigateWithScroll("/otc")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#E0DCD9")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "none",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
            width: "100%", // Menutupi seluruh lebar popover
          }}
        >
          <img
            src={OTCIcon}
            alt="OTC"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              OTC
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Over the counter platform
            </p>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const solutionsPopover = (
    <Popover
      id="solutions-popover"
      ref={popoverRef}
      style={popoverStyle}
      onMouseEnter={() => setSolutionsVisible(true)}
      onMouseLeave={closeAllPopovers}
    >
      <Popover.Body>
        <div
          onClick={() => handleScrollToSection("business")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#F2F2F2")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
          }}
        >
          <img
            src={SolutionIcon1}
            alt="Use Cases"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              Use Cases
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Our fundamental business activities
            </p>
          </div>
        </div>
        <div
          onClick={() => handleScrollToSection("forWhom")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#F2F2F2")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
          }}
        >
          <img
            src={SolutionIcon2}
            alt="Benefits Overview"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              Benefits Overview
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Explore the benefits of Tennet’s product
            </p>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const companyPopover = (
    <Popover
      id="company-popover"
      ref={popoverRef}
      style={popoverStyle}
      onMouseEnter={() => setCompanyVisible(true)}
      onMouseLeave={closeAllPopovers}
    >
      <Popover.Body>
        <div
          onClick={() => handleNavigateWithScroll("/aboutus")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#F2F2F2")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
          }}
        >
          <img
            src={CompanyIcon1}
            alt="About Us"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              About Us
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Our story, teams, and values
            </p>
          </div>
        </div>
        <div
          onClick={() => handleNavigateWithScroll("/whytennet")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#F2F2F2")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
          }}
        >
          <img
            src={CompanyIcon2}
            alt="Why Tennet"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              Why Tennet?
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Explore our technology and certifications
            </p>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );

  const developersPopover = (
    <Popover
      id="developers-popover"
      ref={popoverRef}
      style={popoverStyle}
      onMouseEnter={() => setDevelopersVisible(false)}
      onMouseLeave={closeAllPopovers}
    >
      <Popover.Body>
        <div
          onClick={() => handleNavigateWithScroll("/home")}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#F2F2F2")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px",
            cursor: "pointer",
          }}
        >
          <img
            src={DeveloperIcon1}
            alt="API"
            style={{ width: "30px", marginRight: "15px" }}
          />
          <div>
            <h4
              style={{
                fontSize: "18px",
                color: "#214D73",
                fontWeight: "600",
                marginBottom: "0px",
              }}
            >
              API
            </h4>
            <p
              style={{
                fontSize: "0.875rem",
                color: "#6D6D6D",
                marginBottom: "0px",
              }}
            >
              Documentation
            </p>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  );
  const [bgColor, setBgColor] = useState("transparent");

  useEffect(() => {
    if (location.pathname === "/terms" || location.pathname === "/privacy") {
      setBgColor("#0A6DA8");
    } else {
      setBgColor(isScrolled ? "#0A6DA8" : "transparent");
    }
  }, [location, isScrolled]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuOpen = (event, setter) => {
    setter(event.currentTarget);
  };

  const handleMenuClose = (setter) => {
    setter(null);
  };

  const handleDrawerToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };


  return (
    <AppBar
      position="fixed"
      sx={{
        padding: isMobile ? "10px 15px" : "10px 70px",
        paddingBottom: "8px",
        backgroundColor: bgColor,
        boxShadow: isScrolled ? "0 4px 12px rgba(0, 0, 0, 0.1)" : "none",
        transition: "background-color 0.3s ease, box-shadow 0.3s ease",
      }}
      className={`header ${isScrolled ? "scrolled" : ""}`}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Desktop: Logo */}
        <Box display="flex" alignItems="center">
          <img
            src={Logo}
            alt="Logo"
            style={{ height: "30px", cursor: "pointer" }}
            onClick={handleScrollToHome}
          />
        </Box>

        {/* Right Section: Book a meeting, Divider, Globe Icon */}
        <Box display="flex" alignItems="center">
          {!isMobile && (
            <>
              <OverlayTrigger
                show={isProductsVisible}
                placement="bottom"
                overlay={productsPopover}
              >
                <Button
                  variant="link"
                  style={{
                    fontSize: "15px",
                    color: "#ffffff",
                    textTransform: "none",
                  }}
                  onMouseEnter={() => {
                    closeAllPopovers();
                    setProductsVisible(true);
                  }}
                  onMouseLeave={closeAllPopovers}
                >
                  Products <ArrowDropDownIcon />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                show={isSolutionsVisible}
                placement="bottom"
                overlay={solutionsPopover}
              >
                <Button
                  variant="link"
                  style={{
                    fontSize: "15px",
                    color: "#ffffff",
                    textTransform: "none",
                  }}
                  onMouseEnter={() => {
                    closeAllPopovers();
                    setSolutionsVisible(true);
                  }}
                  onMouseLeave={closeAllPopovers}
                >
                  Solutions <ArrowDropDownIcon />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                show={isCompanyVisible}
                placement="bottom"
                overlay={companyPopover}
              >
                <Button
                  variant="link"
                  style={{
                    fontSize: "15px",
                    color: "#ffffff",
                    textTransform: "none",
                  }}
                  onMouseEnter={() => {
                    closeAllPopovers();
                    setCompanyVisible(true);
                  }}
                  onMouseLeave={closeAllPopovers}
                >
                  Company <ArrowDropDownIcon />
                </Button>
              </OverlayTrigger>

              {/* <OverlayTrigger
                show={isDevelopersVisible}
                placement="bottom"
                overlay={developersPopover}
              >
                <Button
                  variant="link"
                  disabled
                  style={{
                    fontSize: "15px",
                    textTransform: "none",
                  }}
                  onMouseEnter={() => {
                    closeAllPopovers();
                    setDevelopersVisible(false);
                  }}
                  onMouseLeave={closeAllPopovers}
                >
                  Developers <ArrowDropDownIcon />
                </Button>
              </OverlayTrigger> */}
              <button
                style={{
                  backgroundColor: isScrolled ? "#f0f0f0" : "transparent",
                  color: isScrolled ? "#214D73" : "#ffffff",
                  padding: isMobile ? "0.3rem 0.75rem" : "0.3rem 0.75rem",
                  fontSize: isMobile ? "12px" : "13px",
                  borderRadius: "0.5rem",
                  border: isScrolled ? "none" : "1px solid #ffffff",
                  cursor: "pointer",
                  fontWeight: "500",
                  transition:
                    "background-color 0.3s ease, color 0.3s ease, border 0.3s ease",
                  marginLeft: "20px",
                }}
                onClick={handleBookMeeting}
              >
                Book a meeting
              </button>
            </>
          )}

          {/* Mobile: Burger menu on the right */}
          {isMobile && (
            <IconButton color="inherit" onClick={handleToggleDropdown}>
              <MenuIcon />
            </IconButton>
          )}
        </Box>

        {/* Mobile Drawer */}
      </Toolbar>

      {isMobile && (
        <>
          {/* Backdrop for darkening the background when dropdown is open */}
          <Backdrop
            open={isDropdownOpen}
            onClick={() => setIsDropdownOpen(false)}
            sx={{
              zIndex: 9998, // Make sure it's behind the dropdown
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black
            }}
          />

          <Collapse
            in={isDropdownOpen}
            timeout="auto"
            unmountOnExit
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              maxHeight: "2000px", // Full height of the viewport
              background: "#E8E4E1", // Gradient background color
              color: "#214D73", // White font color
              zIndex: 9999, // Ensures it covers other components
            }}
          >
            <Box
              ref={dropdownRef}
              sx={{
                paddingTop: "10px",
                position: "relative",
                height: "100%", // Ensures content fills the height
              }}
            >
              {/* Close Button in the top right corner */}
              <IconButton
                onClick={() => setIsDropdownOpen(false)}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 18,
                  color: "#214D73", // White font color
                }}
              >
                <CloseIcon />
              </IconButton>

              {/* Logo and Divider at the top */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  padding: "10px 0",
                }}
              >
                <img
                  src={Logo2}
                  alt="Tennet Logo"
                  style={{
                    height: "30px",
                    cursor: "pointer",
                    paddingLeft: "20px",
                  }}
                  onClick={handleScrollToHome}
                />
              </Box>
              <Divider sx={{ borderColor: "#214D73", marginBottom: "10px" }} />

              {/* Dropdown menu content */}
              <List component="nav" sx={{ padding: "0 10px" }}>
                {/* Products Section */}
                <ListItem button onClick={() => toggleSection("products")}>
                  <ListItemText primary="Products" sx={{ color: "#214D73" }} />
                  {openSections.products ? (
                    <ExpandLess sx={{ color: "#214D73" }} />
                  ) : (
                    <ExpandMore sx={{ color: "#214D73" }} />
                  )}
                </ListItem>
                <Collapse in={openSections.products} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      onClick={() => handleNavigateWithScroll("/custody")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <img
                          src={CustodyIcon}
                          alt="Custody"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            Custody
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8, // Slightly faded for distinction
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Hot, warm, and cold custody platform
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                    <ListItem
                      button
                      onClick={() => handleNavigateWithScroll("/xcrow")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "none", alignItems: "flex-start" }}>
                        <img
                          src={XcrowIcon}
                          alt="Xcrow"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            Xcrow
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Crypto escrow service platform
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                    <ListItem
                      button
                      onClick={() => handleNavigateWithScroll("/otc")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "none", alignItems: "flex-start" }}>
                        <img
                          src={OTCIcon}
                          alt="OTC"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            OTC
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Over-the-counter trading platform
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                  </List>
                </Collapse>

                {/* Solutions Section */}
                <ListItem button onClick={() => toggleSection("solutions")}>
                  <ListItemText primary="Solutions" sx={{ color: "#214D73" }} />
                  {openSections.solutions ? (
                    <ExpandLess sx={{ color: "#214D73" }} />
                  ) : (
                    <ExpandMore sx={{ color: "#214D73" }} />
                  )}
                </ListItem>
                <Collapse
                  in={openSections.solutions}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      onClick={() => handleScrollToSection("business")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <img
                          src={SolutionIcon1}
                          alt="Our Business"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            Our Business
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Our fundamental business activities{" "}
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                    <ListItem
                      button
                      onClick={() => handleScrollToSection("forWhom")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <img
                          src={SolutionIcon2}
                          alt="For Whom"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            For Whom
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Explore the benefits of Tennet’s product{" "}
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                  </List>
                </Collapse>

                {/* Company Section */}
                <ListItem button onClick={() => toggleSection("company")}>
                  <ListItemText primary="Company" sx={{ color: "#214D73" }} />
                  {openSections.company ? (
                    <ExpandLess sx={{ color: "#214D73" }} />
                  ) : (
                    <ExpandMore sx={{ color: "#214D73" }} />
                  )}
                </ListItem>
                <Collapse in={openSections.company} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      onClick={() => handleNavigateWithScroll("/aboutus")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <img
                          src={CompanyIcon1}
                          alt="About Us"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            About Us
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Our story, team, and values
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                    <ListItem
                      button
                      onClick={() => handleNavigateWithScroll("/whytennet")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <img
                          src={CompanyIcon2}
                          alt="Why Tennet"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            Why Tennet
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Explore our technology and certifications{" "}
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                  </List>
                </Collapse>

                {/* Developers Section */}
                <ListItem onClick={() => toggleSection("developers")}>
                  <ListItemText primary="Developers" sx={{ color: "#214D73" }} />
                  {openSections.developers ? (
                    <ExpandLess sx={{ color: "#214D73" }} />
                  ) : (
                    <ExpandMore sx={{ color: "#214D73" }} />
                  )}
                </ListItem>
                <Collapse
                  in={openSections.developers}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      onClick={() => handleNavigateWithScroll("/api")}
                      sx={{ pl: 4 }}
                    >
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <img
                          src={DeveloperIcon1}
                          alt="API"
                          style={{ width: "40px", marginRight: "10px" }}
                        />
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{ color: "#214D73", fontWeight: "bold" }}
                          >
                            API
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#214D73",
                              opacity: 0.8,
                              fontSize: "0.875rem",
                              lineHeight: "1.2",
                            }}
                          >
                            Documentation{" "}
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                  </List>
                </Collapse>

                {/* Divider */}
                <Divider sx={{ borderColor: "#214D73", marginY: "10px" }} />

                {/* Book a Meeting and Public Icon Side by Side */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    gap: "10px",
                    paddingLeft: "18px",
                    paddingRight: "18px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleBookMeeting}
                    sx={{
                      backgroundColor: "#214D73",
                      color: "#FFFFFF",
                      borderRadius: "8px",
                      textTransform: "none",
                      flex: 1,
                    }}
                  >
                    Book a Meeting
                  </Button>


                </Box>
              </List>
            </Box>
          </Collapse>
        </>
      )}

    </AppBar>
  );
};

export default Header;
